import type { IconName } from '@/content/icons';
import { ICON_PATHS } from '@/content/icons';
import { COMING_SOON_CATEGORY_ID, type ProductEntry } from '@/content/products';
import type { UpcomingProduct } from './content';

/** 后台图标是字符串；官网只认自己有的图标，未知值回落到 clock。 */
function toIconName(value: string): IconName {
  return value in ICON_PATHS ? (value as IconName) : 'clock';
}

/** 把后台的待上新产品映射成产品卡用的条目。 */
export function toUpcomingProduct(item: UpcomingProduct): ProductEntry {
  return {
    id: item.code,
    categoryId: COMING_SOON_CATEGORY_ID,
    name: item.name,
    tagline: item.tagline,
    icon: toIconName(item.icon),
    badge: 'soon',
    status: 'soon',
    note: item.note,
    actions: [{ label: '了解规划', to: '/contact', variant: 'secondary' }],
  };
}
